import React, { useState } from "react";
import { Search } from "lucide-react";
import ExportPrintActions, { ColumnConfig } from "../../../../utils/exportUtils";
import { ServiceData } from "../../../Table/ServicesTable";

interface ServiceFilterProps {
    onSearch: (query: string) => void;
    exportData: { rows: ServiceData[]; columns: ColumnConfig[] };
}

const ServiceFilter: React.FC<ServiceFilterProps> = ({ onSearch, exportData }) => {
    const [query, setQuery] = useState("");

    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 w-full">
            {/* search input */}
            <div className="relative w-full md:w-[40%] lg:w-[30%]">
                <Search
                    className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400"
                    size={18}
                />
                <input
                    type="text"
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        onSearch(e.target.value);
                    }}
                    placeholder="Search"
                    className="border p-3 pl-10 rounded-full w-full bg-white focus:outline-none focus:ring-2 focus:ring-[#B9C3DB]"
                />
            </div>

            {/* export & print */}
            <div className="flex gap-2 w-full md:w-auto justify-end mt-3 md:mt-0">
                <ExportPrintActions
                    rows={exportData.rows}
                    columns={exportData.columns}
                    fileName="services"
                />
            </div>
        </div>

    );
};

export default ServiceFilter;
